import React, { useMemo, useState } from 'react';
import strings from 'strings';
import { FPIconButton } from 'UI/components/atoms';
import FPButtonBuilder from 'UI/components/molecules/FPButtonBuilder';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';
import { buildCloseAndSaveButtonDefinition } from 'UI/components/templates/FPDrawer/FPDrawer.constants';
import { SvgArrowLeft } from 'UI/res';

import ReasonsForm from '../../OptionalSelectorForm';

import { DeclineFormNames, DeclineSchema, NoOfferSchema, NoOfferStatus } from './utils';

/**
 * @typedef {Object} SendoutsDeclineFormProps
 * @property {Function} onClose
 * @property {Function} onBack
 * @property {Function} onSubmitData
 * @property {FormContextValues} form
 * @property {*} type
 */

/**
 * @param {SendoutsDeclineFormProps} props
 */
const SendoutsDeclineForm = ({ onClose, onBack, form, onSubmitData, type }) => {
  const { handleSubmit } = form;
  const [uiState, setUiState] = useState({
    isFormLoading: false,
    isError: false,
    isSaving: false,
    showBackNavigation: true
  });

  const getFormState = useMemo(() => {
    const isNoOffer = NoOfferStatus.some(each => each === type?.id);
    if (isNoOffer)
      return {
        schema: NoOfferSchema,
        title: 'No Offer Reasons'
      };

    // default return..
    return {
      schema: DeclineSchema,
      title: 'Offer declined reasons'
    };
  }, [type]);

  const handleSubmitData = async data => {
    setUiState(prev => ({ ...prev, isSaving: true }));
    await onSubmitData({
      ...data,
      declination_details: {
        [DeclineFormNames.declinedFields.name]: data.declined_fields,
        [DeclineFormNames.declinedNotes.name]: data.declination_notes
      }
    });
    setUiState(prev => ({ ...prev, isSaving: false }));
  };

  const buttonDefinitions = buildCloseAndSaveButtonDefinition({
    onClose,
    isSaveDisabled: uiState.isSaving,
    isSaving: uiState.isSaving
  });

  return (
    <FPDrawer
      FPDrawerProps={{
        open: true
      }}
      CardHeaderProps={{
        title: getFormState.title,
        titleTypographyProps: {
          variant: 'h5'
        },
        avatar: (
          <FPIconButton
            onClick={onBack}
            iconMode="custom"
            icon={SvgArrowLeft}
            tooltipProps={{ title: strings.shared.ui.back }}
          />
        )
      }}
      onClose={onClose}
      ContentWrapper="form"
      ContentWrapperProps={{
        'data-testid': 'checkbox-list-reason-not-offer',
        onSubmit: handleSubmit(handleSubmitData)
      }}
      footer={
        <FPButtonBuilder
          GridContainerProps={{ spacing: 2 }}
          buttonDefinitions={buttonDefinitions}
        />
      }
    >
      <ReasonsForm form={form} schema={getFormState.schema} />
    </FPDrawer>
  );
};

export default SendoutsDeclineForm;
